module.exports = __webpack_public_path__ + "static/media/signing-document.d05fe3c9.jpg";